import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: (p) => p.palette.primary[100],
  borderRadius: (p) => p.spacing(2),
  overflow: 'hidden',
  width: '100%',
};

export const header: SxStyle = {
  color: (p) => p.palette.primary[600],
  background: (p) => p.palette.primary[50],
  px: 2,
  py: 1.5,
  borderBottomWidth: '1px',
  borderBottomStyle: 'solid',
  borderBottomColor: (p) => p.palette.primary[100],
  fontSize: (p) => p.typography.h5.fontSize,
  fontWeight: (p) => p.typography.fontWeightSemiBold,
};
